import { RoleGate, UserRole } from "@/features/auth";
import { useDossierId } from "@/features/dossier-details";
import { TvvDetailsAlleenLezen } from "@/features/tvv/components/alleen-lezen";
import { TvvDetailsRegieCentrumBussen } from "@/features/tvv/components/regiecentrumbussen";
import { TvvDetailsRegievoerder } from "@/features/tvv/components/regievoerder";
import { useArchiveVisibility } from "@/shared/hooks";

export function TvvDetails() {
    const id = useDossierId();
    const isArchived = useArchiveVisibility();

    if (isArchived) {
        return <TvvDetailsAlleenLezen dossierId={id} />;
    }

    return (
        <>
            <RoleGate roles={[UserRole.REGIEVOERDER, UserRole.ADMIN]}>
                <TvvDetailsRegievoerder dossierId={id} />
            </RoleGate>
            <RoleGate roles={[UserRole.TRANSVISION, UserRole.DEWIT]}>
                <TvvDetailsRegieCentrumBussen dossierId={id} />
            </RoleGate>
            <RoleGate roles={[UserRole.ALLEENLEZEN, UserRole.SUPPORTCONSULTANT, UserRole.KLANTENSERVICE]}>
                <TvvDetailsAlleenLezen dossierId={id} />
            </RoleGate>
        </>
    );
}
